import { useCallback, useEffect } from 'react'

// Utils
import { getParsedItem, setStringifiedItem } from '@sketch/utils'

// Constants
import { localStorageKeys } from '@sketch/constants'
import { useModalContext } from 'containers/ModalManager/ModalContext'

// Local Components
import { ShowcaseYourDesignModal } from './ShowcaseYourDesignModal'

export interface UseShowcaseYourDesignModalProps {
  workspaceId: string
}

export const useShowcaseYourDesignModal = (
  props: UseShowcaseYourDesignModalProps
) => {
  const { workspaceId } = props
  const { showModal } = useModalContext()

  const wasAlreadyDismissed = getParsedItem(
    localStorageKeys.dismissedShowcaseYourDesignModal
  )?.includes(workspaceId)

  const shouldRenderModal = !wasAlreadyDismissed

  const onClose = useCallback(() => {
    // Grab all dismissed workspace ID's from local storage
    const previouslyDismissedIDs =
      getParsedItem(localStorageKeys.dismissedShowcaseYourDesignModal) ?? []

    const currentDismissedIDs = [...previouslyDismissedIDs, workspaceId]

    // Set the current workspace ID to the list of dismissed modals
    setStringifiedItem(
      localStorageKeys.dismissedShowcaseYourDesignModal,
      currentDismissedIDs
    )
  }, [workspaceId])

  useEffect(() => {
    if (shouldRenderModal) {
      showModal(ShowcaseYourDesignModal, {
        onClose,
      })
    }
  }, [showModal, shouldRenderModal, workspaceId, onClose])
}
